export const APPLY_URL =
  "https://app.caplessfunding.com/apply/caplessfunding?rep=b7db629c-8442-44d2-9a6c-c749fe18f71f&s=a4eb4514-967a-42be-893f-33da0107d337";

export const APPLY_LINK_PROPS = {
  href: APPLY_URL,
  target: "_blank",
  rel: "noopener noreferrer",
};
